import { render } from "./InstanceCreditBanner.vue?vue&type=template&id=dfca7ba6"
import script from "./InstanceCreditBanner.vue?vue&type=script&lang=js"
export * from "./InstanceCreditBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__